export const SET_TIP_AMOUNT = 'checkout/set_tip_amount';
export const SET_ADDITIONAL_INFO_ERROR_DIALOG =
  'checkout/SET_ADDITIONAL_INFO_ERROR_DIALOG';
export const SET_SELECTED_TIP_PRESET = 'checkout/SET_SELECTED_TIP_PRESET';
